export default "__VITE_ASSET__Hrsc7LMS__"